/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ISocialPostListItem } from '../social-post-schema';
import { socialPostListItemSchema } from '../social-post-schema';

const listDataSchema = z.object({
  items: z.array(socialPostListItemSchema),
  total: z.number(),
});

export interface IListSocialPostsV1Data {
  items: ISocialPostListItem[];
  total: number;
}

export const listSocialPostsV1ResponseSchema = createApiResponseSchema(
  listDataSchema,
) as z.ZodSchema<IAPI<IListSocialPostsV1Data>>;

export type IListSocialPostsV1Response = IAPI<IListSocialPostsV1Data>;
